import { TableContext } from '@/typings/datatable';
import { AxiosError } from 'axios';

export interface FilterParam {
	field: string;
	value: any;
}

export class ApiUtils {
	public static queryOptions = (
		filters: FilterParam[] = [],
		ctx: TableContext,
		options: any = {},
	) => {
		const { params = {} } = options;

		filters.forEach((filter: FilterParam) => {
			if (filter.value) {
				// check multiple
				params[`filter[${filter.field}]`] = filter.value;
				// callback(`filter[${filter.field}]`, filter.value);
			}
		});

		params.perPage = ctx.perPage.toString(10);
		params.page = ctx.currentPage.toString(10);

		if (ctx.sortBy) {
			params.sort = (ctx.sortDesc ? '-' : '') + ctx.sortBy;
		}

		options.params = params;

		return options;
	};

	public static handleApiError(
		e: unknown,
		fallbackMessage: string,
		ctx?: string,
	): { errorMessage: string } {
		const error: AxiosError = e as AxiosError;
		let errorMessage =
			error.response?.data.message ??
			error.response?.data.errors?.errors ??
			error.response?.data.errors ??
			fallbackMessage;
		try {
			const json = JSON.parse(errorMessage);
			errorMessage = json?.errors ?? json;
		} catch (e) {}
		if (Array.isArray(errorMessage)) {
			const count = errorMessage.length;
			const wording = count === 1 ? 'was an error' : `were ${count} errors`;
			const errorsConcat = [
				...new Set(
					errorMessage.map(
						err =>
							err.message +
							(err.value != null ? ` (${err.path != null ? `${err.path} ` : ''}${err.value})` : ''),
					),
				),
			].join(', ');
			return { errorMessage: `There ${wording}${ctx ? ` ${ctx}` : ''}: ${errorsConcat}` };
		}
		if (errorMessage.length === 0)
			errorMessage = `Error ${error.response?.status ?? 'Unknown'}: ${error.response?.statusText ??
				'Unknown reason'}`;
		return { errorMessage };
	}
}
